<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ userId ? 'Edit ' + userId : 'Add Customer' }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <div class="pa-4" v-if="isChargeback === '1'">
        <v-container fluid grid-list-xs class="red darken-2 pa-3">
          <v-layout row wrap>
            <v-flex xs3 sm1 class="text-xs-center">
              <v-avatar>
                <v-icon class="large notranslate white red--text">priority_high</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex xs5 sm8>
              <h3 class="title font-weight-bold white--text">Chargeback User</h3>
              On {{ chargebackDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
            </v-flex>
            <v-flex xs4 sm3 class="text-xs-right">
              <v-btn
                outline
                class="mr-2"
                :to="'/customer/' + userId + '/orders'"
              >
                View
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-form ref="form" v-model="frmValid">
        <v-container grid-list-lg class="pa-4">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="txtEmail"
                :rules="[v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Invalid email format']"
                :counter="150"
                label="E-mail"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtPassword"
                v-if="!userId"
                label="Password"
                :type="'password'"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select
                v-model="cboTitle"
                :items="titles"
                :rules="[v => !!v || 'Please select title']"
                label="Title"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                v-model="txtFirstName"
                :rules="[v => !!v || 'First name is required']"
                :counter="50"
                label="First Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                v-model="txtLastName"
                :counter="50"
                label="Last Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="txtPhone"
                :rules="[v => !!v || 'Phone is required']"
                :counter="50"
                label="Handphone"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                v-model="cboTimezone"
                :items="timezones"
                label="Timezone"
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="userId">
              <v-select
                v-model="cboType"
                :items="types"
                :rules="[v => !!v || 'Please select type']"
                label="Type"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId && cboType==='wholesale' && !dtWholesalePeriodEndDate">
              <v-select
                v-model="cboWholesalePeriodNumOfDay"
                :items="periodDays"
                :rules="[v => !!v || 'Please select days']"
                label="Period Days"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId && cboType==='wholesale' && dtWholesalePeriodEndDate && dtWholesalePeriodEndDate.length > 0">
              <v-menu
                ref="menuWholesalePeriodEndDate"
                :close-on-content-click="false"
                v-model="dtWholesalePeriodEndDatePicker"
                :nudge-right="40"
                :return-value.sync="dtWholesalePeriodEndDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dtWholesalePeriodEndDate"
                  label="Period End Date"
                  :rules="[v => !!v || 'Period end date is required']"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dtWholesalePeriodEndDate" no-title scrollable @input="$refs.menuWholesalePeriodEndDate.save(dtWholesalePeriodEndDate)"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId && cboType==='wholesale'">
              <v-text-field
                v-model="txtWholesalePeriodTargetPurchase"
                :rules="[v => !!v || 'Target purchase is required']"
                prefix="$"
                label="Target Purchase"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="userId && cboType==='wholesale'">
              <v-menu
                ref="menuWholesaleFirstPurchaseDateline"
                :close-on-content-click="false"
                v-model="dtWholesaleFirstPurchaseDatelinePicker"
                :nudge-right="40"
                :return-value.sync="dtWholesaleFirstPurchaseDateline"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dtWholesaleFirstPurchaseDateline"
                  label="First purchase dateline"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dtWholesaleFirstPurchaseDateline" no-title scrollable @input="$refs.menuWholesaleFirstPurchaseDateline.save(dtWholesaleFirstPurchaseDateline)"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>
              <v-btn
                block
                color="primary"
                :disabled="!frmValid"
                @click="submit"
              >
                Save
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId">
              <v-btn block @click.stop="dialogResetPassword = true">
                Reset Password
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId">
              <v-btn outline block :to="'/customer/' + userId + '/orders'">
                Order History
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 v-if="userId">
              <v-btn outline block v-if="isAccessTransaction" :to="'/customer/' + userId + '/transactions'">
                Transactions
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <div class="pa-4">
        <user-notes-box v-model="userNotes" :userId="userId"></user-notes-box>
      </div>
      <v-container grid-list-lg class="pa-4" v-if="dtWholesaleFirstPurchaseDateline && dtWholesaleFirstPurchaseDateline.length > 0">
        <h2>Wholesale First Purchase</h2>
        <v-layout row wrap>
          <v-flex xs12 v-if="wholesaleFirstPurchaseDateTime">
            <v-icon small class="green--text mr-1">check_circle_outline</v-icon> {{ wholesaleFirstPurchaseDateTime | formatDate('D MMM YYYY', profile.gmtTimezone) }}
          </v-flex>
          <v-flex xs12 v-else>
            <v-icon small class="orange--text mr-1">hourglass_empty</v-icon> No wholesale first purchase yet
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-lg class="pa-4" v-if="wholesalePeriods.length > 0">
        <h2>Wholesale Periods</h2>
        <v-layout row wrap>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 v-for="period in wholesalePeriods" :key="period.wholesalePeriodId">
            <div>
              {{ period.periodStartDateTime | formatDate('D MMM YYYY', '+00:00') }} - {{ period.periodEndDateTime | formatDate('D MMM YYYY', '+00:00') }} <span :class="getPeriodStatusClass(period.status)">{{ period.status | allCaps }}</span>
            </div>
            <div class="mb-3">
              <strong>Total purchase:</strong> {{ def.currency.sign }}{{ formatPrice(period.totalPurchase) }} / {{ def.currency.sign }}{{ formatPrice(period.targetPurchase) }}
            </div>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialogResetPassword" max-width="300px">
        <v-card>
          <v-card-title>
            <strong>Reset Password</strong>
          </v-card-title>
          <v-card-text>
            <v-form ref="formResetPassword" v-model="frmResetPasswordValid" @submit.prevent="">
              <v-text-field
                label="Password"
                v-model="txtNewPassword"
                :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                :type="'password'"
                required
              ></v-text-field>
              <v-text-field
                label="Confirm Password"
                v-model="txtNewPassword2"
                :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                :type="'password'"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmResetPasswordValid"
                @click="submitResetPassword()"
              >
                Reset
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import UserNotesBox from '@/components/UserNotesBox.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'userId'
  ],
  components: {
    SideDrawer,
    UserNotesBox,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      frmValid: true,
      txtEmail: '',
      txtPassword: '',
      cboTitle: '',
      txtFirstName: '',
      txtLastName: '',
      txtPhone: '',
      cboTimezone: '',
      cboType: 'retail',
      types: ['retail', 'wholesale'],
      isAccessTransaction: false,
      cboWholesalePeriodNumOfDay: 0,
      periodDays: [7, 30, 60, 90, 180, 365],
      txtWholesalePeriodTargetPurchase: 0,
      dtWholesalePeriodEndDate: null,
      dtWholesalePeriodEndDatePicker: false,
      dtWholesaleFirstPurchaseDateline: null,
      dtWholesaleFirstPurchaseDatelinePicker: false,
      dialogResetPassword: false,
      frmResetPasswordValid: false,
      txtNewPassword: '',
      txtNewPassword2: '',
      wholesalePeriods: [],
      isChargeback: '0',
      chargebackDateTime: '',
      userNotes: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCustomer(this.userId)

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-TRANSACTION' && this.profile.permissions[i].isRead === '1') {
          this.isAccessTransaction = true
          break
        }
      }
    }
  },

  methods: {
    getPeriodStatusClass: function (status) {
      var result = 'caption white---text pa-1 ml-3'
      if (status === 'active' || status === 'renewed') {
        result = result + ' green darken-2'
      } else {
        result = result + ' red'
      }
      return result
    },
    getCustomer: function (userId) {
      if (userId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + userId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtEmail = resp.data.data.loginEmail
              this.cboTitle = resp.data.data.title
              this.txtFirstName = resp.data.data.firstName
              this.txtLastName = resp.data.data.lastName
              this.txtPhone = resp.data.data.phone
              this.cboTimezone = resp.data.data.gmtTimezone
              this.cboType = resp.data.data.type
              this.wholesalePeriods = resp.data.data.wholesalePeriods
              this.txtWholesalePeriodTargetPurchase = resp.data.data.wholesalePeriodTargetPurchase
              this.dtWholesalePeriodEndDate = resp.data.data.wholesalePeriodEndDateTime.substring(0, 10)
              this.dtWholesaleFirstPurchaseDateline = resp.data.data.wholesaleFirstPurchaseDateline.substring(0, 10)
              this.wholesaleFirstPurchaseDateTime = resp.data.data.wholesaleFirstPurchaseDateTime
              this.isChargeback = resp.data.data.isChargeback
              this.chargebackDateTime = resp.data.data.chargebackDateTime
              this.userNotes = resp.data.data.notes
            } else {
              console.log('unable to load customer details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.userId) {
          this.loading = true
          var submitData = {
            loginEmail: this.txtEmail,
            title: this.cboTitle,
            firstName: this.txtFirstName,
            lastName: this.txtLastName,
            phone: this.txtPhone,
            gmtTimezone: (this.cboTimezone.length > 0 ? this.cboTimezone : null),
            type: this.cboType,
            wholesalePeriodTargetPurchase: this.txtWholesalePeriodTargetPurchase,
            wholesalePeriodEndDateTime: this.dtWholesalePeriodEndDate + ' 23:59:59'
          }
          if (this.cboWholesalePeriodNumOfDay > 0) {
            var todayDate = new Date()
            todayDate.setDate(todayDate.getDate() + this.cboWholesalePeriodNumOfDay)
            var dd = todayDate.getDate()
            dd = ('0' + dd).slice(-2)
            var mm = todayDate.getMonth() + 1
            mm = ('0' + mm).slice(-2)
            var y = todayDate.getFullYear()
            submitData.wholesalePeriodEndDateTime = y + '-' + mm + '-' + dd + ' 23:59:59'
          }
          if (typeof this.dtWholesaleFirstPurchaseDateline !== 'undefined' && this.dtWholesaleFirstPurchaseDateline !== null && this.dtWholesaleFirstPurchaseDateline.length > 0) {
            submitData.wholesaleFirstPurchaseDateline = this.dtWholesaleFirstPurchaseDateline + ' 23:59:59'
          }
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId, submitData, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/customers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/user', {
            loginEmail: this.txtEmail,
            password: this.txtPassword,
            title: this.cboTitle,
            firstName: this.txtFirstName,
            lastName: this.txtLastName,
            phone: this.txtPhone,
            gmtTimezone: (this.cboTimezone.length > 0 ? this.cboTimezone : null)
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/customers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    },
    submitResetPassword () {
      if (this.$refs.formResetPassword.validate()) {
        if (this.userId) {
          if (this.txtNewPassword === this.txtNewPassword2) {
            this.loading = true
            axios.put(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId, {
              password: this.txtNewPassword
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                this.loading = false
                console.log(resp.data)
                if (resp.data.status === 'success') {
                  window.alert('Password has been reset')
                  this.dialogResetPassword = false
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    this.showAlert(error)
                  }
                  this.loading = false
                }
              })
          } else {
            window.alert('Password mismatch')
          }
        }
      }
    }
  }
}
</script>
